module.exports = __webpack_public_path__ + "img/tablet.e6351264.png";